import { useSelector } from 'react-redux';
import { isAllFeedBucket } from '../redux/selectors/bucket';
import { NCNotification } from '../types/nc';

export function useNotificationBiString(notification: NCNotification) {
  const isAllFeed = useSelector(isAllFeedBucket);
  return notificationToBiString(notification, isAllFeed);
}

export function notificationToBiString(notification: NCNotification, isAllFeed: boolean): string {
  return JSON.stringify({
    message_id: notification.messageId,
    type: notification.type,
    message_class: notification.messageClass,
    bucket: notification.bucket,
    originator: notification.originator?.userId,
    folderId: notification.folderId,
    ts: notification.ts,
    is_all_feed: isAllFeed ? 1 : 0,
  });
}
